import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const CrossIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M8.72 8.72a.75.75 0 0 1 1.06 0l2.47 2.47 2.47-2.47a.75.75 0 1 1 1.06 1.06l-2.47 2.47 2.47 2.47a.75.75 0 1 1-1.06 1.06l-2.47-2.47-2.47 2.47a.75.75 0 0 1-1.06-1.06l2.47-2.47-2.47-2.47a.75.75 0 0 1 0-1.06Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
